function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#EF8432",
  d: "M4.47 16a4.472 4.472 0 01-3.162-7.63L3.66 6.017a.855.855 0 111.21 1.21L2.518 9.58a2.76 2.76 0 103.902 3.901l2.352-2.351a.856.856 0 011.21 1.21L7.63 14.692A4.443 4.443 0 014.47 16zM14.692 1.308a4.474 4.474 0 010 6.322l-2.351 2.35a.856.856 0 11-1.211-1.21l2.352-2.351A2.76 2.76 0 009.58 2.517L7.23 4.869a.856.856 0 11-1.211-1.21L8.37 1.308a4.474 4.474 0 016.322 0zM10.97 5.03a.856.856 0 010 1.21l-4.73 4.73a.855.855 0 11-1.209-1.211L9.76 5.03a.856.856 0 011.21 0z"
})));